/**
 * ISO week helpers for week-based date filtering.
 * Week 1 is the week containing the first Thursday of the year.
 */

export function getISOWeek(date) {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const dayNum = d.getUTCDay() || 7; // Mon = 1, Sun = 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return { week: weekNo, year: d.getUTCFullYear() };
}

export function getStartOfISOWeek(year, week) {
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const dayNum = jan4.getUTCDay() || 7;
  const monday = new Date(jan4);
  monday.setUTCDate(jan4.getUTCDate() - dayNum + 1);
  const start = new Date(monday);
  start.setUTCDate(monday.getUTCDate() + (week - 1) * 7);
  start.setUTCHours(0, 0, 0, 0);
  return start;
}

export function getEndOfISOWeek(year, week) {
  const start = getStartOfISOWeek(year, week);
  const end = new Date(start);
  end.setUTCDate(start.getUTCDate() + 6);
  end.setUTCHours(23, 59, 59, 999);
  return end;
}

const MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatWeekLabel(week, year) {
  const start = getStartOfISOWeek(year, week);
  const month = MONTH_ABBR[start.getUTCMonth()];
  return `Week ${week} - ${month} ${year}`;
}

/** Generate last N weeks (including current) for dropdown options */
export function getLastWeeks(count = 12) {
  const options = [];
  const today = new Date();
  let { week, year } = getISOWeek(today);
  for (let i = 0; i < count; i++) {
    options.push({ week, year, label: formatWeekLabel(week, year) });
    week -= 1;
    if (week < 1) {
      week = 52;
      year -= 1;
    }
  }
  return options;
}
